'use strict';

// noinspection JSValidateTypes
/**
 * @ngdoc function
 * @name gfcmsApp.controller:ScheduleDetailsCtrl
 * @description
 * # ScheduleDetailsCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('ScheduleDetailsCtrl', ScheduleDetailsController);

ScheduleDetailsController.$inject = [
  '$location',
  '$route',
  '$routeParams',
  '$timeout',
  'modalService',
  'momentService',
  'moment',
  'uiCalendarConfig',
  'schedulePrepService'
];


function ScheduleDetailsController($location, $route, $routeParams, $timeout,
                                   modalService, momentService,
                                   moment, uiCalendarConfig,
                                   schedulePrepService) {

  var scheduleVm = this;
  var isScheduleUser = $route.current.action === 'personalise';

  scheduleVm.id = $routeParams.scheduleId;
  scheduleVm.jobId = $routeParams.jobId;
  scheduleVm.dayId = $routeParams.dayId;
  scheduleVm.getEventDetails = getEventDetails;
  scheduleVm.activate = activate;
  scheduleVm.render = render;
  /**
   * @type {boolean}
   */
  scheduleVm.isScheduleUser = isScheduleUser;
  scheduleVm.jobs = schedulePrepService.jobs;
  scheduleVm.schedule = schedulePrepService.schedule;
  scheduleVm.eventSources = [{
    events: schedulePrepService.jobs,
    // color: '#449d44', // an option!
    textColor: 'white' // an option!
  }];

  // noinspection JSUnusedLocalSymbols
  scheduleVm.uiConfig = {
    calendar: {
      height: 450,
      editable: false,
      header: {
        left: 'month agendaWeek agendaDay',
        center: 'title',
        right: 'prev,next'
      },
      minTime: '08:00:00',
      maxTime: '17:00:00',
      businessHours: {
        start: '09:00',
        end: '16:00'
      },
      weekends: false,
      eventDurationEditable: false,
      eventClick: scheduleVm.getEventDetails,
      eventRender: function (event, element, view) {
        element.find('.fc-content').attr('id', 'event-' + event.id);
      },
      defaultView: 'agendaDay',
      defaultDate: getDefaultDate(scheduleVm.eventSources[0].events[0]),
      validRange: {
        start: momentService.getMonthStart(scheduleVm.schedule.monthYearFor).format('YYYY-MM-DD'),
        end: momentService.getMonthEnd(scheduleVm.schedule.monthYearFor).add(1, 'hour').format('YYYY-MM-DD')
      },
      timezone: 'local'
    }
  };

  activate();

  return scheduleVm;

  function activate() {
    if (scheduleVm.isScheduleUser) {
      return;
    }

    $timeout(function () {
      triggerEventClick();
    }, 1);
  }

  /**
   * @param {Job} event
   */
  function getEventDetails(event) {
    var eventDetails = '<strong>Customer</strong>: ' + event.title +
      '<br/><strong>Address</strong>: ' + event.address +
      '<br/><strong>Job Date</strong>: ' + event.start.format('dddd, MMMM Do YYYY') +
      '<br/><strong>Duration</strong>: ' + event.duration + ' hours' +
      '<br/><strong>Notes</strong>: ' + (!!event.notes ? event.notes : 'No notes available');

    scheduleVm.modalOptions = {
      headerText: 'Job Details',
      bodyText: eventDetails
    };
    modalService.showModal({}, scheduleVm.modalOptions);
  }

  function triggerEventClick() {
    if (!!scheduleVm.jobId) {
      angular.element('#event-' + scheduleVm.jobId + '.fc-content').trigger('click');
    }
  }

  function getDefaultDate(event) {
    if (!!scheduleVm.dayId) {
      return momentService.getMomentFromDayId(scheduleVm.dayId);
    }

    if (!!event) {
      return moment(event.jobDate);
    }

    return getMonthStart(scheduleVm.schedule.monthYearFor);
  }

  function getMonthStart(monthYearFor) {
    var monthMoment = moment(monthYearFor, 'MMMM YYYY');
    var first = moment(monthMoment).startOf('month');
    return first.day() % 6 === 0 ? first.add(1, 'day').day(1) : first;
  }

  function render() {
    setTimeout(function () {
      uiCalendarConfig.calendars['fcalendar'].fullCalendar('rerenderEvents');
    }, 0);
  }
}
